import React from 'react';
interface Category {
  id: string;
  name: string;
}
interface PredictionCategoriesProps {
  categories: Category[];
  activeCategory: string;
  onSelectCategory: (categoryId: string) => void;
}
export const PredictionCategories = ({
  categories,
  activeCategory,
  onSelectCategory
}: PredictionCategoriesProps) => {
  return <div className="mb-8 overflow-x-auto" data-id="element-226">
      <div className="flex space-x-2 pb-2" data-id="element-227">
        {categories.map(category => <button key={category.id} onClick={() => onSelectCategory(category.id)} className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${activeCategory === category.id ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-800 hover:bg-gray-200'}`} data-id="element-228">
            {category.name}
          </button>)}
      </div>
    </div>;
};